const TruncatedText = ({ text, lines = 2 }) => {
  return (
    <span className="truncate" style={{ WebkitLineClamp: lines}}>{text}</span>
  );
}

export default TruncatedText;